import React, { useState } from 'react';
import Button from "./Button";
import {IosShare} from "@mui/icons-material";
import Tooltip from "./Tooltip";
import { exportToCsv } from "../utils/csvExportUtils";

const ExportToCsvButton = ({
                               data,
                               fetchDataForExport,
                               columns,
                               fileName = 'export.csv',
                               disabled = false,
                               disabledTooltipText = 'Select a class with data to allow CSV export',
                               buttonText = 'Export to CSV' }) => {

    const [isLoading, setIsLoading] = useState(false);

    const handleDownload = async () => {
        setIsLoading(true);

        try {
            // Use fetchDataForExport if provided, otherwise use data prop
            const exportData = fetchDataForExport ? await fetchDataForExport() : data;
            await exportToCsv(exportData, columns, fileName);
        } catch (error) {
            console.error('Error during export:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const isDisabled = disabled || isLoading;

    if (isDisabled) {
        return (
            <Tooltip title={isLoading ? 'Exporting data...' : disabledTooltipText}>
                <Button disabled={true} type={'outline'} onClick={handleDownload} icon={<IosShare />}>
                    {buttonText}
                </Button>
            </Tooltip>
        )
    }

    return (
        <Button type={'outline'} onClick={handleDownload} icon={<IosShare />}>
            {buttonText}
        </Button>
    );
};

export default ExportToCsvButton;